import { render } from "./TeacherProfileView.vue?vue&type=template&id=3557a5af&scoped=true"
import script from "./TeacherProfileView.vue?vue&type=script&lang=js"
export * from "./TeacherProfileView.vue?vue&type=script&lang=js"

import "./TeacherProfileView.vue?vue&type=style&index=0&id=3557a5af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3557a5af"]])

export default __exports__